import ouiBase from '@goldwasserexchange/oui';
import { useBondListFieldApiBySAccId } from '../api';

export const useBondListSQuotePriceClose = () => {
  const sAccId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const response = useBondListFieldApiBySAccId({
    sAccId,
    field: 'S_QUOTE.PRICE_CLOSE',
  });
  return response;
};
